import { Game } from 'constants/Game';

export const gameNameFromId = (gameId?: string) =>
  Object.values(Game).find((gameProps) => gameProps.id === gameId)?.name;

export const gameIdFromTabName = (tabName: string) =>
  Object.values(Game).find((gameProps) => gameProps.tabName === tabName)?.id;

export const isWeeklyDraw = (gameId?: string) => gameId === Game.WeeklyDraw.id;

export const raffleSelected = (gameType: string) =>
  [Game.DailyPoundRaffle.id, Game.IcelandRaffle.id].includes(gameType);

export const tokenTownSelected = (gameId?: string) => gameId === Game.TokenTown.id;

export const isLotteryGameType = (gameType?: string) => {
  return gameType === 'LOTTERY';
};

export const isMainLotteryDraw = (code?: string) => {
  return code === 'DAYMADEDRAW';
};

interface GameSelectorProps {
  setSelectedGameId: (gameId: string) => void;
  selectedGameId?: string;
  hiddenSections?: string[];
}

const GameSelector = ({
  selectedGameId,
  setSelectedGameId,
  hiddenSections = [Game.OtherRaffles.id],
}: GameSelectorProps) => {
  return (
    <div className="gameSelector fullWidth flexCentered">
      <div className="filterOptions">
        <img
          src="https://img.spacergif.org/v1/spacer.gif"
          width="1em"
          height="1"
          alt=""
          style={{ width: '1em' }}
        />

      {Object.values(Game).map((game) => {
        const selected = game.id === selectedGameId;

        if (hiddenSections.includes(game.id)) {
          return null;
        }

        return (
          <div
            key={game.id}
            className={`filterOption${selected ? ' selected' : ''}`}
            onClick={() => setSelectedGameId(game.id)}
          >
            <div className="imageContainer">
              <img src={game.thumbnail} className="filterIcon" alt="" />

              <img
                src={game.selectedIcon}
                className="overlaySelectedIcon"
                alt=""
              />
            </div>

            <div className="filterName">{game.name}</div>
          </div>
        );
      })}

      <img
        src="https://img.spacergif.org/v1/spacer.gif"
        width="1em"
        height="1"
        alt=""
        style={{ width: '1em' }}
      />
    </div>

    <style jsx>
      {`
        .gameSelector {
          background: #f6f6f6;
          padding-bottom: 2em;
        }

        .filterOptions {
          display: flex;
          justify-content: flex-start;
          width: auto;
          max-width: 100%;
          padding: 1em 0;
          overflow-x: auto;
        }

        .filterOptions::-webkit-scrollbar {
          display: none;
        }

        .filterOption {
          cursor: pointer;
          width: -moz-fit-content;
          width: fit-content;
          margin: 1em 1em 0;
          flex-grow: 1;
          text-align: center;
          transition: 0.2s;
        }

        .filterName {
          min-width: 100px;
        }

        .imageContainer {
          display: inline-flex;
          position: relative;
          height: 60px;
          width: 60px;
          border-radius: 50%;
        }

        .filterIcon,
        .overlaySelectedIcon {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          overflow: hidden;
          transition: 0.2s;
        }

        .filterIcon {
          width: 54px;
          height: 54px;
          left: calc(50% - 27px);
          top: calc(50% - 27px);
        }

        .overlaySelectedIcon {
          opacity: 0;
        }

        .filterName {
          font-weight: 600;
          transition: 0.2s;
          white-space: nowrap;
        }

        .filterOption.selected > .imageContainer > .filterIcon {
          opacity: 0;
          transition: 0.2s;
        }

        .filterOption.selected > .imageContainer > .overlaySelectedIcon {
          opacity: 1;
          transition: 0.2s;
        }

        .filterOption.selected .filterName {
          font-weight: 700;
          text-shadow: 0 0 2px rgba(0, 255, 221, 0.9);
          transition: 0.2s;
        }
      `}
    </style>
  </div>
)};

export default GameSelector;
